<template>
  <div id="selectDepartment" class="selectDepartment" v-if="!disabled">
    <div class="actionBar">
      <a class="fl" href="javascript:void(0)" @click="close">取消</a>
      <a class="fr" href="javascript:void(0)" @click="affirm">选中</a>
      <div class="clear"></div>
    </div>
    <div class="department">
        <span v-for="item in departmentNav" :data-id="item.id" @click="select(item.id)">
            <template v-if="origin_data[item.name]">
                <Organization :name="item.name" type="departmentName" :openid="item.name" :useOpenData="origin_data[item.name].useOpenData" ></Organization>
            </template>
            <template v-else>
                {{item.name}}
            </template>
        </span>
    </div>
    <div class="resultList">
      <ul>
        <li v-for="item in departmentList.list" :data-id="item.id" @click="select(item.id)">
            <span>
                <Organization :name="item.deptName" type="departmentName" :openid="item.deptName" :useOpenData="item.useOpenData" ></Organization>
            </span>
          <i
            v-if="current && item.id == current.id"
            :data-deptId="item.treeIdPath"
            @click="setCurrent($event,null)"
            class="circle selected"
          ></i>
          <i
            v-if="!current || item.id != current.id"
            :data-deptId="item.treeIdPath"
            @click="setCurrent($event,item)"
            class="circle"
          ></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Organization from "@/components/common/organization.vue";
export default {
  data() {
    return {
        disabled: true,
        list: null,
        current: null,
        id: 0,
        origin_data:{}
    };
  },
  components:{
      Organization
  },
  computed: {
    ...mapGetters({
      departmentList: "getDepartmentList"
    }),
    departmentNav() {
        console.log('this.departmentList',this.departmentList);
      let navList = [];
      if (this.departmentList.agh6Department) {
        let idArray = this.departmentList.agh6Department.treeIdPath.split("/");
        let nameArray = this.departmentList.agh6Department.treeNamePath.split(
          "/"
        );
        idArray.forEach((id, key) => {
          let item = {
            id: id,
            name: nameArray[key]
          };
          navList.push(item);
        });
      }
        if(this.departmentList.list&&this.departmentList.list.length > 0){
            this.departmentList.list.forEach(item=>{
                this.origin_data[item.deptName] = item;
            })
        }
        return navList;
    },
    currentNav() {
      let navList = [];
      if (this.current) {
        let idArray = this.current.treeIdPath.split("/");
        let nameArray = this.current.treeNamePath.split("/");
        let current = this.current;
        idArray.forEach((id, key) => {
          let item = {
            id: id,
            name: nameArray[key]            
          };
          navList.push(item);
        });
      }
      return navList;
    },
    departmentPath() {
      let len = this.currentNav.length;
      let list = [];
      if (len > 4) {
        list.push({
          id: this.currentNav[0].id,
          name: this.currentNav[0].name
        });
        list.push({
          id: this.currentNav[1].id,
          name: this.currentNav[1].name
        });
        list.push({
          id: this.currentNav[2].id,
          name: "..."
        });
        list.push({
          id: this.currentNav[len - 1].id,
          name: this.currentNav[len - 1].name
        });
      } else {
        list = this.currentNav;
      }
      return list;
    }
  },
  methods: {
    show() {
      this.disabled = false;
    },
    close() {
      this.disabled = true;
    },
    affirm() {
      if (null == this.current && this.departmentList.agh6Department) {
        this.current = this.departmentList.agh6Department;
      }
      this.disabled = true;
      this.$emit("callback", {
        list: this.departmentPath,
        current: this.current,
        origin_data: this.origin_data
      });
    },
    setCurrent(e, item) {
      e.stopPropagation();
      this.current = item;
    },
    select(id) {
      this.current = null;
      this.loadData(id);
    },
    loadData(id) {
      this.id = id;
      let params = {
        parentId: this.id
      };
      this.$store.dispatch("getDepartmentList", params);
    }
  },
  watch:{
    disabled(cVal){
      console.log('setDepartmentDisabled');
      this.$emit("setDepartmentDisabled", this.disabled);
    }
  },
  created() {
    this.loadData(this.id);
  }
};
</script>